import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"
import _imports_0 from './assets/images/logo1.png'
import _imports_1 from './assets/images/users2x.png'
import _imports_2 from './assets/images/users1x.png'


const _hoisted_1 = {
  key: 0,
  id: "app"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Logezy Reference ")
const _hoisted_4 = { class: "main-menu" }
const _hoisted_5 = {
  key: 0,
  class: "candidateListSec"
}
const _hoisted_6 = { class: "candidateorders" }
const _hoisted_7 = { class: "candidaLists" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "user2"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    class: "user1"
  })
], -1)
const _hoisted_10 = { class: "right" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "email" }
const _hoisted_13 = {
  key: 1,
  class: "QProfileMenus"
}
const _hoisted_14 = { class: "header" }
const _hoisted_15 = {
  key: 0,
  class: "firstcnt"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Question Profile", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" New Profile ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_19 = {
  key: 1,
  class: "showRemoveForm"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_21 = { class: "questionProfileLists" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "left" }
const _hoisted_24 = {
  key: 0,
  class: "right"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 1,
  class: "right",
  style: {"background":"transparent"}
}
const _hoisted_27 = {
  key: 2,
  class: "QProfileMenus"
}
const _hoisted_28 = { class: "questionProfileLists" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, " Agencies ", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, " Credit Prices ", -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, " Organisations ", -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "site-header"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Question Profile")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Users")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Billing")
const _hoisted_39 = { class: "submenu-title-wrapper" }
const _hoisted_40 = { class: "smenus" }
const _hoisted_41 = { class: "left" }
const _hoisted_42 = { class: "right" }
const _hoisted_43 = { class: "name" }
const _hoisted_44 = { class: "aname" }
const _hoisted_45 = { class: "smenus credit" }
const _hoisted_46 = { class: "left" }
const _hoisted_47 = { class: "ccount" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, "credit remaining", -1)
const _hoisted_49 = { class: "smenus" }
const _hoisted_50 = { class: "left" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, "Account Setting", -1)
const _hoisted_52 = { class: "smenus" }
const _hoisted_53 = { class: "left" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, "Logout", -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" © 2021 - v 2022.01.07.1 ")
const _hoisted_56 = { key: 1 }
const _hoisted_57 = {
  key: 1,
  class: "spinners"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_unfold_outlined = _resolveComponent("menu-unfold-outlined")!
  const _component_menu_fold_outlined = _resolveComponent("menu-fold-outlined")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_QuestionCircleFilled = _resolveComponent("QuestionCircleFilled")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")!
  const _component_LogoutOutlined = _resolveComponent("LogoutOutlined")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_page_header = _resolveComponent("a-page-header")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_ctx.$route.name)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (
        _ctx.$route.name != 'Login' &&
        _ctx.$route.name != 'Home' &&
        _ctx.$route.name != 'Page Not Found' &&
        _ctx.$route.name != 'Signup' &&
        _ctx.$route.name !== 'Referee' &&
        _ctx.$route.name !== 'Candidate' &&
        _ctx.$route.name !== 'Candidate Referee'
      )
          ? (_openBlock(), _createBlock(_component_a_layout, {
              key: 0,
              id: "components-layout-demo-custom-trigger"
            }, {
              default: _withCtx(() => [
                (_ctx.profile)
                  ? (_openBlock(), _createBlock(_component_a_layout_sider, {
                      key: 0,
                      theme: "light",
                      class: "CsideMenu",
                      width: "300",
                      breakpoint: "lg",
                      collapsed: _ctx.collapsed,
                      "onUpdate:collapsed": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.collapsed) = $event)),
                      collapsible: "",
                      trigger: null
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "headers",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dashboardPage && _ctx.dashboardPage(...args)))
                        }, [
                          _createElementVNode("div", {
                            class: "Bmenu",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toogleMenu && _ctx.toogleMenu(...args)))
                          }, [
                            (_ctx.collapsed)
                              ? (_openBlock(), _createBlock(_component_menu_unfold_outlined, {
                                  key: 0,
                                  class: "trigger"
                                }))
                              : (_openBlock(), _createBlock(_component_menu_fold_outlined, {
                                  key: 1,
                                  class: "trigger"
                                }))
                          ]),
                          _hoisted_2,
                          _hoisted_3
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          (_ctx.$route.name == 'Dashboard' || _ctx.$route.name == 'Referee Details')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_a_input_search, {
                                  value: _ctx.searchCandidate,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchCandidate) = $event)),
                                  placeholder: "Search candidate",
                                  allowClear: "",
                                  style: {"width":"90%"},
                                  onSearch: _ctx.onCandidateSearch
                                }, null, 8, ["value", "onSearch"]),
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["lists", _ctx.candidateFilterType === 'All' ? 'Active' : '']),
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.candidateFilters('All')))
                                  }, "All ", 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["lists", _ctx.candidateFilterType === 'Oldest' ? 'Active' : '']),
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.candidateFilters('Oldest')))
                                  }, "Oldest ", 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["lists", _ctx.candidateFilterType === 'New' ? 'Active' : '']),
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.candidateFilters('New')))
                                  }, "New ", 2)
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCandidates, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["singlecandidate", _ctx.activeCandidateKey === item.id ? 'active' : '']),
                                      key: item.id,
                                      onClick: ($event: any) => (_ctx.candidateDetails(item))
                                    }, [
                                      _hoisted_9,
                                      _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, _toDisplayString(item.candidate_name), 1),
                                        _createElementVNode("div", _hoisted_12, _toDisplayString(item.email), 1)
                                      ])
                                    ], 10, _hoisted_8))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.$route.name == 'Questions Profile')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  (_ctx.commonService.checkPermission('Question Profile', 'create'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createVNode(_component_QuestionCircleFilled),
                                        _hoisted_16,
                                        (!_ctx.addqProfileForm)
                                          ? (_openBlock(), _createBlock(_component_a_button, {
                                              key: 0,
                                              type: "primary",
                                              block: "",
                                              class: "newprofile",
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addNewQuestionProfile()))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_17
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_a_button, {
                                              key: 1,
                                              type: "primary",
                                              block: "",
                                              class: "newprofile",
                                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addNewQuestionProfile()))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_18
                                              ]),
                                              _: 1
                                            }))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.addqProfileForm)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _createVNode(_component_a_input, {
                                          placeholder: "Profile Name",
                                          value: _ctx.qProfileName,
                                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.qProfileName) = $event)),
                                          type: "text",
                                          "allow-clear": ""
                                        }, null, 8, ["value"]),
                                        _createVNode(_component_a_button, {
                                          type: "primary",
                                          block: "",
                                          class: "newprofile",
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveNewQuestionProfile())),
                                          loading: _ctx.saveNewProfileLoading
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_20
                                          ]),
                                          _: 1
                                        }, 8, ["loading"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allQuestions, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["singleQuestion", _ctx.activeQuestionKey === item.id ? 'active' : '']),
                                      key: item.id,
                                      onClick: ($event: any) => (_ctx.questionDetails(item))
                                    }, [
                                      _createElementVNode("div", _hoisted_23, _toDisplayString(item.profile_name), 1),
                                      (_ctx.commonService.checkPermission('Question Profile', 'delete'))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                            _createElementVNode("span", {
                                              onClick: ($event: any) => (_ctx.showDeleteQuestionConfirm(item.id))
                                            }, [
                                              _createVNode(_component_DeleteOutlined)
                                            ], 8, _hoisted_25)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_26))
                                    ], 10, _hoisted_22))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.$route.name == 'Agencies' || _ctx.$route.name == 'Prices' || _ctx.$route.name == 'Organisation' || _ctx.$route.name == 'Agency Details')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["singleQuestion superadmin", _ctx.$route.name === 'Agencies' || _ctx.$route.name === 'Agency Details' ? 'active' : '']),
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.superAdminPages('agencies')))
                                  }, _hoisted_30, 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["singleQuestion superadmin", _ctx.$route.name === 'Prices' ? 'active' : '']),
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.superAdminPages('prices')))
                                  }, _hoisted_32, 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["singleQuestion superadmin", _ctx.$route.name === 'Organisation' ? 'active' : '']),
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.superAdminPages('organisations')))
                                  }, _hoisted_34, 2)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["collapsed"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_layout, { style: {"background":"#fff"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_layout_header, {
                      style: {"background":"#fff","padding":"0","height":"auto"},
                      class: "app-c-Header"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.$route.name != 'Authorize')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _createVNode(_component_a_page_header, null, {
                                extra: _withCtx(() => [
                                  _createVNode(_component_a_dropdown, {
                                    overlayClassName: "secMenu",
                                    placement: "bottomRight"
                                  }, _createSlots({
                                    default: _withCtx(() => [
                                      _createElementVNode("a", {
                                        class: "ant-dropdown-link",
                                        onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"]))
                                      }, [
                                        _createTextVNode(_toDisplayString(_ctx.profile?.role_name) + " ", 1),
                                        (_ctx.profile.role_id !== 1)
                                          ? (_openBlock(), _createBlock(_component_DownOutlined, { key: 0 }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, [
                                    (_ctx.profile.role_id !== 1)
                                      ? {
                                          name: "overlay",
                                          fn: _withCtx(() => [
                                            _createVNode(_component_a_menu, { onClick: _ctx.onMenuClick }, {
                                              default: _withCtx(() => [
                                                (_ctx.profile.role_id !== 2 ? _ctx.checkPermission('Question Profile') : _ctx.profile.role_name === 'admin')
                                                  ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "1" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_36
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                                _createVNode(_component_a_menu_item, { key: "2" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_37
                                                  ]),
                                                  _: 1
                                                }),
                                                (_ctx.profile.role_id !== 2 ? _ctx.checkPermission('Billing') : _ctx.profile.role_name === 'admin')
                                                  ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "3" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_38
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ])
                                        }
                                      : undefined
                                  ]), 1024),
                                  _createVNode(_component_a_menu, { class: "headerRightIcons" }, {
                                    default: _withCtx(() => [
                                      (_ctx.profile)
                                        ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                                            key: "sub4",
                                            popupClassName: "Hprofile"
                                          }, {
                                            title: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_39, [
                                                _createVNode(_component_a_avatar, {
                                                  src: 
                            _ctx.profile.photo
                              ? _ctx.profile.photo
                              : 'https://ui-avatars.com/api/?background=57429d&name=' +
                                _ctx.profile.first_name +
                                '&rounded=true&color=ffffff'
                          
                                                }, null, 8, ["src"])
                                              ])
                                            ]),
                                            default: _withCtx(() => [
                                              (_ctx.$route.name != 'Authorize')
                                                ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                                    key: "20",
                                                    onClick: _ctx.dashboardPage
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_40, [
                                                        _createElementVNode("div", _hoisted_41, [
                                                          _createVNode(_component_a_avatar, {
                                                            src: 
                              _ctx.profile.photo
                                ? _ctx.profile.photo
                                : 'https://ui-avatars.com/api/?background=57429d&name=' +
                                  _ctx.profile.first_name +
                                  '&rounded=true&color=ffffff'
                            
                                                          }, null, 8, ["src"])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_42, [
                                                          _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.profile?.first_name + ' ' +_ctx.profile?.last_name), 1),
                                                          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.profile?.agency_name), 1)
                                                        ])
                                                      ])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["onClick"]))
                                                : _createCommentVNode("", true),
                                              (_ctx.profile.role_id !== 1)
                                                ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                                    key: "21",
                                                    onClick: _ctx.billingPage
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_45, [
                                                        _createElementVNode("div", _hoisted_46, [
                                                          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.avilablecredit), 1)
                                                        ]),
                                                        _hoisted_48
                                                      ])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["onClick"]))
                                                : _createCommentVNode("", true),
                                              (_ctx.profile.role_id !== 1)
                                                ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                                    key: "22",
                                                    onClick: _ctx.userProfile
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_49, [
                                                        _createElementVNode("div", _hoisted_50, [
                                                          _createVNode(_component_SettingOutlined)
                                                        ]),
                                                        _hoisted_51
                                                      ])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["onClick"]))
                                                : _createCommentVNode("", true),
                                              _createVNode(_component_a_menu_item, {
                                                key: "23",
                                                onClick: _ctx.logout
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_52, [
                                                    _createElementVNode("div", _hoisted_53, [
                                                      _createVNode(_component_LogoutOutlined)
                                                    ]),
                                                    _hoisted_54
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_layout_content, { style: {
            minHeight: '90vh',
            margin: '25px',
            background: '#F9F9FB',
            borderRadius: '20px'
          } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_view, {
                          onGetCandidates: _ctx.getAllcandidate,
                          onGetAllQuestions: _ctx.getAllQuestionProfile,
                          onUpdateCreditPoint: _ctx.getAvailableCreditPoint,
                          onUpdateProfile: _ctx.updateMenu,
                          CandidateId: _ctx.activeCandidateKey,
                          QuestioProfileId: _ctx.activeQuestionKey
                        }, null, 8, ["onGetCandidates", "onGetAllQuestions", "onUpdateCreditPoint", "onUpdateProfile", "CandidateId", "QuestioProfileId"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_layout_footer, { style: {"text-align":"center"} }, {
                      default: _withCtx(() => [
                        _hoisted_55
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (
        _ctx.$route.name == 'Login' ||
        _ctx.$route.name == 'Home' ||
        _ctx.$route.name == 'Page Not Found' ||
        _ctx.$route.name == 'Signup' ||
        _ctx.$route.name == 'Referee' || _ctx.$route.name == 'Candidate' || _ctx.$route.name == 'Candidate Referee'
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createVNode(_component_router_view)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_57, [
        _createVNode(_component_a_spin)
      ]))
}